import AxiosGlobalInstance, { AxiosPromise, IConsorcieiResponse } from '@/services/index';

/**
 * List all groups for a specific administrator
 * @param {string} admExternalId - Administrator ID to filter groups
 * @returns {AxiosPromise<IConsorcieiResponse<Record<string, unknown>>>} Promise with axios response
 */
export async function listGroups(admExternalId: string): AxiosPromise<IConsorcieiResponse<Array<Record<string, unknown>>>> {
  if (!admExternalId) {
    throw new Error('admExternalId is required');
  }

  return AxiosGlobalInstance.get(`/group/list`, {
    params: {
      admId: admExternalId
    }
  }).then((response) => ({
    ...response,
    data: {
      groups: response?.data?.groups?.map((group: { number: string }) => ({ number: group.number }))
    }
  }));
}
